<template>
  <div v-if="facture && activeTab" class="section is-paddingless"
    :class="{'section-details': !isBrouillon }">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ getTitle }} </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('general.button.cancel')}}
            </button>
            <button
              @click="save()"
              class="button is-addOrEdit">
              {{ isBrouillon
                ? $t('addEditFactureAchat.actions.save')
                : $t('general.button.sauvegarder') }}
            </button>
            <piece-jointe-button
              :perm="permission.maj"
              class="mgr-2">
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component
      v-if="error"
      :error="error"
      :messages="messages"
      :champs-vide="champsVide"
      :messages-champs-vide="messagesChampsVide"
      @close="error = $event"
      class="mgt-20px"
      title="general.problemOccurred"
      withEmplyFields/>
    <div class="tab">
      <ul>
        <li
          v-for="(tab, index) in tabs" :key="index"
          :class="{'is-active': activeTab === tab}"
          @click="activeTab = tab">
          <b-field>
            <div v-if="tab === 'rapprochement'"
              class="mgv-auto mgr-5px"
              :class="getColorStatusRapprochement"></div>
            <span> {{ $t(`addEditFactureAchat.tabs.${tab}`) }}</span>
          </b-field>
        </li>
      </ul>
    </div>
    <section class="corps">
      <component
        v-if="facture"
        :is="activeTab"
        :facture="facture"
        :factureDetail="facture"
        :devisCommande="facture"
        :detailDevisCommande="factureDetail"
        :datePaiementBase="datePaiement"
        :query="query"
        :moduleType="constantes.MODULE_ACHAT"
        :sens="constantes.SENS_ACHAT"
        :commandeAchatARapprocher="commandeAchatARapprocher"
        @refreshCommandeAchat="updateCommandeArapprocher"
        @tiersUpdated="resetCommandeArapprocher"/>
      <piece-jointe
        v-if="activeTab === 'informationsTab'"
        :checkPermissions="true"
        class="mgt-20px"/>
    </section>
    <b-modal
      v-model="popUpPrevention"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('addEditFactureAchat.popUpPrevention.title')"
        :messDescription="$t('addEditFactureAchat.popUpPrevention.subTitle')"
        :validate="$t('general.button.next')"
        :cancel="$t('general.button.cancel')"
        @yes="continuWithLigneWithoutDate"
        @no="popUpPrevention = false"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import {
  get, create, update,
  updateFactureEnregistrer,
} from '@/api/factureAchatARapprocher';
import { get as getTiers } from '@/api/tiers';
import { updateEcheancierPaiement } from '@/api/echeancierPaiement';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/baux/factureAchatArapprocher/validation/validationFactureAchat';
import translator from '@/services/baux/factureAchatArapprocher/validation/translate';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import prepareFactureAchatAlreadyPayeOrSave from '@/services/baux/factureAchatArapprocher/prepareFactureAchatAlreadyPayeOrSave';
import echeancierGeneration from '@/services/facture/generationEcheancier';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import { initializePostGet, initializeDefault, initializeCommandeAchatRapprochement } from '@/services/achat/factures/factureAchatServices';
import genererCritereRechercheRapprochement from '@/services/achat/factures/genererCritereRechercheRapprochement';
import * as devisConf from '@/configuration/devisConf';
import * as typesfacture from '@/store/modules/facture-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { FACTURES } from '@/configuration/achat/permissionsConf';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/facture/factureConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import PopUpPrevention from '@/components/general/popUpPrevention';
import FactureDetailTab from '@/components/factures/factureDetail';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import EcheancierPaiementTab from '@/components/factures/echeancierPaiement';
import PieceJointeButton from '@/components/general/button/pieceJointeButton';
import PieceJointe from '@/components/baux/contrat/componentEdition/pieceJointe';
import InformationsTab from '@/components/baux/factureAchatARapprocher/edition/factureAchatInformation/factureInformation';
import rapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/rapprochement';
import { getAllEcheancier } from '@/api/commandeAchat';
import sortCommandeAchat from '@/services/baux/commandeAchat/sortCommandeAchat';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import calculArrondi from '@/services/calcul/calculArrondi';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Attachments = createNamespacedHelpers('attachments');
const Factures = createNamespacedHelpers('facture');

export default {
  name: 'MFactureAchatFournisseur',
  components: {
    PieceJointe,
    AppBreadcrumb,
    PopUpPrevention,
    InformationsTab,
    FactureDetailTab,
    ErrorMsgComponent,
    PieceJointeButton,
    EcheancierPaiementTab,
    rapprochement,
  },
  data() {
    return {
      code: '',
      nomCommercial: '',
      activeTab: null,
      facture: null,
      factureDetail: null,
      datePaiement: null,
      error: false,
      continue: false,
      saveAnyway: false,
      popUpPrevention: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      montantTtcSave: 0,
      permission: FACTURES,
      commandeAchatARapprocher: [],
      query: genererCritereRechercheRapprochement(),
      constantes: {
        MODULE_ACHAT: devisConf.MODULE_ACHAT,
        SENS_ACHAT: devisConf.SENS_ACHAT,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    ...Factures.mapGetters({
      avoirACreer: 'avoirACreer',
    }),
    tabs() {
      return [
        { name: 'informationsTab', show: this.isBrouillon },
        { name: 'factureDetailTab', show: !this.isBrouillon },
        { name: 'echeancierPaiementTab', show: true },
        { name: 'rapprochement', show: !this.isAvoir },
      ].filter((tab) => tab.show).map((tab) => tab.name);
    },
    dataAlreadyExist() {
      return this.facture && !!(this.facture.id);
    },
    isAvoir() {
      return [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE].includes(this.facture.sousType);
    },
    getTitle() {
      const textAdd = this.isAvoir ? 'addAvoir' : 'add';
      const textEdit = this.isAvoir ? 'editAvoir' : 'edit';
      return this.dataAlreadyExist
        ? this.$t(`addEditFactureAchat.title.${textEdit}`) + ' ' + this.code
        : this.$t(`addEditFactureAchat.title.${textAdd}`);
    },
    breadcrumb() {
      const textAdd = this.isAvoir ? 'addAvoir' : 'add';
      const textEdit = this.isAvoir ? 'editAvoir' : 'edit';
      const title = this.dataAlreadyExist
        ? this.$t(`addEditFactureAchat.breadcrumb.${textEdit}`)
        : this.$t(`addEditFactureAchat.breadcrumb.${textAdd}`);
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditFactureAchat.breadcrumb.liste'), route: { name: 'l.achat.factures' }, isActive: false },
        { title, route: { name: '' }, isActive: true },
      ];
    },
    isBrouillon() {
      return this.facture.etat === devisConf.ETAT_BROUILLON;
    },
    checkDateLignes() {
      if (this.continue) return false;
      return this.facture.lignesCommande.some((ligne) => {
        const { dateDebut, dateFin } = ligne;
        return !dateDebut || !dateFin || moment(dateDebut).isSame(moment(dateFin));
      });
    },
    montantAvoir() {
      const t = this.facture.avoirsAffectes
        .map(a => Math.abs(a.montantHt))
        .reduce((partialSum, a) => partialSum + a, 0);
      return t;
    },
    montantARapprocher() {
      return this.facture.montantHt - this.montantAvoir;
    },
    getColorStatusRapprochement() {
      if (this.commandeAchatARapprocher.length === 0) return 'round-circle-danger';
      const montantAffecter = this.commandeAchatARapprocher
        .map((echeance) => echeance.montantAffecter)
        .reduce((a, b) => calculArrondi(a + b));
      if (montantAffecter === this.montantARapprocher && this.montantARapprocher > 0) {
        return 'round-circle-success';
      }
      if (montantAffecter < this.montantARapprocher || this.montantARapprocher === 0) {
        return 'round-circle-warning';
      }
      return 'round-circle-danger';
    },
  },
  methods: {
    ...Attachments.mapActions({
      insertAttachments: 'insert',
      updateAttachments: 'update',
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Factures.mapMutations({
      setAvoirACreer: typesfacture.SET_AVOIR_A_CREER,
    }),
    continuWithLigneWithoutDate() {
      this.popUpPrevention = false;
      this.continue = true;
      this.saveFacture();
    },
    updateDatePaiement(date) {
      this.datePaiement = date;
      if (this.facture.echeancierPaiement.length !== 1) return;
      this.facture.echeancierPaiement[0].dateEcheance = date;
    },
    async generationEcheancierPaiementSauvegarde(facture) {
      if (facture.echeancierPaiement.length > 1
        || (facture.echeancierPaiement.length === 1
          && facture.montantTtc === this.montantTtcSave)) {
        return;
      }
      facture.echeancierPaiement = (await echeancierGeneration({
        nombreEcheances: 1,
        periodicite: devisConf.MOIS,
        modeReglementId: facture.modeReglementId,
        datePremiereEcheance: this.datePaiement || this.facture.dateDevisCommande,
        montantTotal: facture.montantTtc - (facture.montantAcomptesAffectes || 0),
      })).data.result;
    },
    async save() {
      if (this.isBrouillon) {
        await this.saveFacture();
      } else {
        await this.saveFactureAlreadyPayeOrSave();
      }
    },
    async saveFacture() {
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];

      if (this.checkDateLignes) {
        this.popUpPrevention = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.generationEcheancierPaiementSauvegarde(this.facture);
        let factureCopy = preparationEnvoiBack(this.facture);
        factureCopy.echeancierPaiement.forEach((f) => {
          f.dateEcheance = formatIsoDate(f.dateEcheance);
        });
        factureCopy.rapprochements = this.getCommandeAchatARapprocher();
        if (!this.dataAlreadyExist) {
          factureCopy.module = devisConf.MODULE_ACHAT;
          factureCopy.societeId = this.societeActiveId;
          factureCopy = (await create(factureCopy)).data.result;
          await this.insertAttachments(factureCopy.id);
          messageSucces(this.$t('addEditFactureAchat.notifications.successCreation'));
        } else {
          factureCopy = (await update(factureCopy)).data.result;
          await this.updateAttachments(factureCopy.id);
          messageSucces(this.$t('addEditFactureAchat.notifications.successChange'));
        }
        this.$router.push({ name: 'c.achat.factures', params: { id: factureCopy.id } });
      } catch (e) {
        if (e.response?.data?.error) {
          validation(e.response, this.messages, devisConf.MODULE_ACHAT);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translator);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async saveFactureAlreadyPayeOrSave() {
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];

      const loadingComponent = this.$buefy.loading.open();
      try {
        const donneeForBack = prepareFactureAchatAlreadyPayeOrSave(
          this.facture,
          this.getCommandeAchatARapprocher(),
        );
        await updateEcheancierPaiement({
          factureId: this.facture.id,
          echeanciersPaiement: donneeForBack.echeanciers,
        });
        await updateFactureEnregistrer(donneeForBack.factureModifiee);
        await this.updateAttachments(donneeForBack.factureModifiee.id);
        messageSucces(this.$t('addEditFactureAchat.messages.success.editFaturePayed'));
        await this.$router.push({
          name: 'c.achat.factures',
          params: {
            id: donneeForBack.factureModifiee.id,
          },
        });
      } catch (e) {
        if (e.response?.data?.error) {
          validation(e.response, this.messages, devisConf.MODULE_ACHAT);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translator);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async initializeFactureDetail(facture) {
      if (facture.etat === devisConf.ETAT_BROUILLON) return;
      const detailFacture = detailDevisCommande(facture);
      const { tiersId } = detailFacture.destinataireComptable;
      const { compteComptable } = (await getTiers(tiersId)).data.result;
      detailFacture.destinataireComptable.compteComptable = compteComptable;
      this.factureDetail = detailFacture;
    },
    getCommandeAchatARapprocher() {
      const rapprochementGeneral = [];

      // si on a modifier des rapprochement on les mets a jour et on les pushs
      this.facture.rapprochements.forEach((rapprochement) => {
        const rapprochementFind = this.commandeAchatARapprocher.find((commandeAchat) => {
          return commandeAchat.id === rapprochement.id;
        });
        if (rapprochementFind) {
          rapprochement.montant = rapprochementFind.montantAffecter;
          rapprochementGeneral.push({
            id: rapprochementFind.id,
            montant: rapprochementFind.montantAffecter,
          });
        }
      });

      // Si on ajoute des nouveaux rapprochement on les ajoutes
      this.commandeAchatARapprocher.forEach((commandeAchat) => {
        if (commandeAchat.montantAffecter !== 0
          && !this.facture.rapprochements.find((rapprochement) => {
            return rapprochement.id === commandeAchat.id;
          })) {
          rapprochementGeneral.push({
            id: commandeAchat.id,
            montant: commandeAchat.montantAffecter,
          });
        }
      });

      return rapprochementGeneral;
    },
    async loadCommandeAchatRapprochement(tiersId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let listeCommandeARapprocher = [];

        // recuperation des CA avec montant affecté
        listeCommandeARapprocher = this.commandeAchatARapprocher
          .filter((echeance) => {
            return echeance.montantAffecter !== 0;
          });
        listeCommandeARapprocher
          .forEach((commandeAchat) => {
            commandeAchat.isIntoActualSearch = false;
          });

        // get des CA avec filtre
        const query = cloneDeep(this.query);
        query.societeId = this.societeActiveId;
        query.module = devisConf.MODULE_ACHAT;
        if (query.codesDossier) {
          query.codes = query.codesDossier;
          delete query.codesDossier;
        }
        query.datesPremierAffichage.dateDebut = formatIsoDate(
          query.datesPremierAffichage.dateDebut,
        );
        query.datesPremierAffichage.dateFin = formatIsoDate(query.datesPremierAffichage.dateFin);
        query.tiersId = [tiersId];
        const newCommandesAchat = (await getAllEcheancier({
          query: query,
          limit: NO_PAGINATION,
        })).data.result.items;
        newCommandesAchat.forEach((echeance) => {
          echeance.montantAffecter = 0;
          echeance.isIntoActualSearch = true;
        });

        // Remise en place des CA précédement léttré + indicateur sur CA pour griser
        newCommandesAchat.forEach((newCommande) => {
          const commandeAlreadyExist = listeCommandeARapprocher.find((commandeSave) => {
            return commandeSave.id === newCommande.id;
          });
          if (!commandeAlreadyExist) listeCommandeARapprocher.push(newCommande);
          else commandeAlreadyExist.isIntoActualSearch = true;
        });
        sortCommandeAchat(listeCommandeARapprocher);
        this.commandeAchatARapprocher = listeCommandeARapprocher;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw e;
      }
    },
    addCommandeAchatDejaLettre(rapprochements) {
      const results = initializeCommandeAchatRapprochement(rapprochements, this.$route.params.id);
      const commandeARapprocher = this.commandeAchatARapprocher
        .filter((c) => !results.find((r) => r.id === c.id));
      results.push(...commandeARapprocher);
      this.commandeAchatARapprocher = results;
    },
    async resetCommandeArapprocher() {
      if (
        this.facture.intervenants.length > 0
        && this.facture.intervenants[0].tiersId !== null
      ) {
        this.commandeAchatARapprocher = [];
        await this.loadCommandeAchatRapprochement(this.facture.intervenants[0].tiersId);
        messageSucces(this.$i18n.t('addEditFactureAchat.messages.success.sucessReinitialisationRapprochement'));
      }
    },
    async updateCommandeArapprocher() {
      await this.loadCommandeAchatRapprochement(this.facture.intervenants[0].tiersId);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      await this.setAttachmentContext({ module: 'Facture' });
      let factureGet = genererDevisCommande(
        devisConf.TYPE_FACTURE,
        devisConf.NORMAL,
        this.societeActive,
        devisConf.SENS_ACHAT,
        devisConf.MODULE_ACHAT,
      );
      if (this.$route.params.id) {
        factureGet = (await get(this.$route.params.id)).data.result;
        initializePostGet(factureGet);
        this.code = cloneDeep(factureGet.code);
        await this.initializeFactureDetail(factureGet);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.code }));
        await this.setAttachmentElementId({ id: factureGet.id });
        await this.loadCommandeAchatRapprochement(factureGet.intervenants[0].tiersId);
        this.addCommandeAchatDejaLettre(factureGet.rapprochements);
      } else if (this.avoirACreer) {
        factureGet = cloneDeep(this.avoirACreer);
        this.setAvoirACreer(null);
      } else {
        initializeDefault(factureGet, this.agencesSelectionnees);
        this.setInformationPage(this.$t('pageAchat.factures.creation'));
      }
      this.facture = cloneDeep(factureGet);
      this.montantTtcSave = this.facture.montantTtc;
      this.activeTab = this.tabs[this.isBrouillon ? 0 : 1];
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
